import { JsonProperty, Serializable } from 'ts-jackson'

@Serializable()
export class AccessControlDoor {
  @JsonProperty('id')
  id!: string

  @JsonProperty('fitnessId')
  fitnessId!: string

  @JsonProperty('branchId')
  branchId!: string

  @JsonProperty('doorNumber')
  doorNumber!: string

  @JsonProperty('vendorDoorId')
  vendorDoorId!: string

  @JsonProperty('name')
  name!: string

  @JsonProperty('location')
  location!: string

  @JsonProperty('direction')
  direction!: string

  @JsonProperty('isActive')
  isActive!: boolean

  @JsonProperty('createdAt')
  createdAt!: string

  @JsonProperty('updatedAt')
  updatedAt!: string
}

export interface ReplaceAccessControlCardCredentialPayload {
  userId: number
  cardUid: string
  expiredAt?: string | null
}

export interface ReplaceAccessControlCardCredentialResponse {
  correlationId?: string
  [key: string]: unknown
}

export interface AccessControlCardCredentialResponse {
  cardUid?: string
  [key: string]: unknown
}
